import React, { useEffect, useState } from "react";
import { useMutation } from "@apollo/client";
import { Grid } from "@material-ui/core";
import mutations from "Shared/mutations";
import {
  ExportPresettlementExclusionReportMutation,
  ExportPresettlementExclusionReportMutationVariables,
} from "generated/graphql";
import { errorToast, successToast } from "Modules/DPToast";
import { AmplitudeEventType } from "Shared/Analytics/Amplitude/Types/AmplitudeEventType";
import { AmplitudeProvider } from "Shared/Analytics/Amplitude";
import { PayDateSelect } from "./PayDateSelect/PayDateSelect";
import useStyles from "./styles";
import { SearchInput } from "./SearchInput/SearchInput";
import { DPExportButton } from "Components/DP";
import { usePresettlementExclusionsHook } from "../PresettlementExclusionsTable/usePresettlementExclusionsHook";
import { usePayPeriodExpectedDates } from "../usePayPeriodExpectedDates";

export const PresettlemetExclusionActions = () => {
  const classes = useStyles();
  const [exportReportFn] = useMutation<
    ExportPresettlementExclusionReportMutation,
    ExportPresettlementExclusionReportMutationVariables
  >(mutations.EXPORT_PRESETTLEMENT_EXCLUSION_REPORT);

  const { payDate } = usePresettlementExclusionsHook();
  const { expectedDates } = usePayPeriodExpectedDates();
  const mostRecentPayDate = expectedDates ? expectedDates[0] : "";
  const selectedPayDate = payDate || mostRecentPayDate;
  const [disableExportButton, setDisableExportButton] = useState(false);

  useEffect(() => {
    setDisableExportButton(false);
  }, [payDate]);

  const handleExportButtonClick = async () => {
    AmplitudeProvider.logEvent({
      type: AmplitudeEventType.ReportExportClicked,
      payload: { tab: "Payday Exclusions Report" },
    });

    setDisableExportButton(true);
    try {
      const exportResponse = await exportReportFn({
        variables: {
          paymentExpectedOn: payDate,
        },
      });
      successToast(exportResponse.data!.exportPresettlementExclusionReport.message);
    } catch (e) {
      setDisableExportButton(true);
      errorToast("Failed to export report.");
    }
  };

  return (
    <Grid
      item xs={12}
      container
      justify="space-between"
      alignItems="center"
      className={classes.container}
    >
      <PayDateSelect
        selectedPayDate={selectedPayDate}
        expectedDates={expectedDates || []}
      />
      <SearchInput />
      <Grid item xs={4} container justify="flex-end" alignItems="flex-end">
        <DPExportButton
          handleExport={handleExportButtonClick}
          disabled={disableExportButton}
        />
      </Grid>
    </Grid>
  );
};
